import React from 'react';
import { useInit } from '../../../../../../Contexts/InitProvider';
import LayoutProvider from '../../../../../../Contexts/LayoutProvider';
import PendingTableMobile from './PendingTableMobile';
import PendingTableWeb from './PendingTableWeb';
import TableMobile from './TableMobile';
import TableWeb from './TableWeb';

function TabAgencyServicesPage({ data }) {
    const { initInfo } = useInit();

    const { initiate, implement, ongoing, done } = initInfo.steps || {};
    return (
        <>
            <LayoutProvider>
                <TableWeb
                    layout="default"
                    data={data}
                    initiate={initiate}
                    implement={implement}
                    ongoing={ongoing}
                    done={done}
                />
                <TableMobile
                    layout={['md', 'sm', 'xs', 'xxs']}
                    data={data}
                    initiate={initiate}
                    implement={implement}
                    ongoing={ongoing}
                    done={done}
                />
            </LayoutProvider>
            <LayoutProvider>
                <PendingTableWeb
                    layout="default"
                    data={data?.pendingServices}
                    initiate={initiate}
                    implement={implement}
                    ongoing={ongoing}
                    done={done}
                />
                <PendingTableMobile
                    layout={['md', 'sm', 'xs', 'xxs']}
                    data={data}
                    initiate={initiate}
                    implement={implement}
                    ongoing={ongoing}
                    done={done}
                />
            </LayoutProvider>
        </>
    );
}

export default TabAgencyServicesPage;
